var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 220,
    viewBox: "0 0 1280 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.04 157.561C1293.04 157.561 1293.52 156.868 1294 156.522C1177.88 72.669 1026.58 15.15 869.99 3.369C712.431 -10.491 555.836 20.001 414.66 65.739C275.893 111.13 154.954 173.847 60.0334 215.427C-36.3326 258.393 -115.353 279.183 -191 270.52C-190.518 270.867 -190.036 271.56 -189.555 271.906C-113.907 280.915 -34.8871 260.472 60.9971 217.852C155.436 176.272 276.375 113.556 414.66 67.818C555.355 22.08 711.949 -8.412 869.508 5.10149C1026.58 16.8825 1177.4 73.7085 1293.04 157.215V157.561Z",
    fill: "#149C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLine);
export default __webpack_public_path__ + "static/media/LandingLine.99f61f326254f175c66e6cc4d98d9bed.svg";
export { ForwardRef as ReactComponent };